import { observable } from "mobx";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class TimeSpan {
  @observable
  ticks?: number;

  readonly days?: number;

  readonly hours?: number;

  readonly milliseconds?: number;

  readonly microseconds?: number;

  readonly nanoseconds?: number;

  readonly minutes?: number;

  readonly seconds?: number;

  readonly totalDays?: number;

  readonly totalHours?: number;

  readonly totalMilliseconds?: number;

  readonly totalMicroseconds?: number;

  readonly totalNanoseconds?: number;

  readonly totalMinutes?: number;

  readonly totalSeconds?: number;
}
